import baseApi from 'api/baseApi';
import { IPersonSearchBarValues } from 'common/components/ManualCheckInPanel/components/PersonSearchBar/interfaces';
import { IPaginatedData } from 'common/interfaces/pagination';
import { ICheckInManuallySearch } from '../interfaces';

const kidZoneMember = baseApi.injectEndpoints({
  endpoints: builder => ({
    getKidZoneMembers: builder.query<
      IPaginatedData<ICheckInManuallySearch>,
      { page?: number; perPage?: number; search?: IPersonSearchBarValues }
    >({
      query: options => ({
        url: '/api/v1/kid-zone/search',
        method: 'GET',
        params: { page: options.page, perPage: options.perPage, ...options.search },
      }),
    }),
  }),
});

export const { useLazyGetKidZoneMembersQuery: useLazyGetKidZoneMembers } = kidZoneMember;

export default kidZoneMember;
